/**
 * @generated SignedSource<<a73902afa7d365af47c6b6b3d1c2dc32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ContractStatus = "active" | "deleted" | "expired" | "offer_draft" | "offer_made" | "offer_processing" | "offer_rejected" | "offer_revoked" | "paused" | "rejected";
import { FragmentRefs } from "relay-runtime";
export type Job_Job$data = {
  readonly contract: {
    readonly status: ContractStatus;
  } | null | undefined;
  readonly firm: {
    readonly name: string | null | undefined;
    readonly slug: string | null | undefined;
  } | null | undefined;
  readonly slug: string | null | undefined;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"JobClientActions_Job" | "JobFooter_Job" | "JobHead_Job" | "JobHeader_Job" | "JobPosting_Job" | "job_useApplyToJob">;
  readonly " $fragmentType": "Job_Job";
};
export type Job_Job$key = {
  readonly " $data"?: Job_Job$data;
  readonly " $fragmentSpreads": FragmentRefs<"Job_Job">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Job_Job",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Firm",
      "kind": "LinkedField",
      "name": "firm",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Contract",
      "kind": "LinkedField",
      "name": "contract",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobHead_Job"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobHeader_Job"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobPosting_Job"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobClientActions_Job"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobFooter_Job"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "job_useApplyToJob"
    }
  ],
  "type": "Job",
  "abstractKey": null
};
})();

(node as any).hash = "e6fb862c2bf624f5729e72238e229f73";

export default node;
